<template>
    <div>
        {{ isShow ? checkEmail : email }}
        <i class="iconfont icon-yanjing-biyan" @click="checkShow(true)" v-if="!isShow && !isPdf"></i>
        <i class="iconfont icon-yanjing" @click="checkShow(false)" v-if="isShow && !isPdf"></i>
    </div>
</template>

<script>
import { AssessApi } from '../config/apis.js';
/**
 * 对手机号和邮箱进行处理
 */
export default {
    props: ['email', 'guid', 'privacyType'],
    data() {
        return {
            checkEmail: '',
            isShow: false,
            isPdf: false
        }
    },
    watch: {

    },
    mounted() {
        if (location.hash.indexOf('pdf') > -1) { 
            this.isPdf = true
        }
    },
    methods: {
        checkShow(show) {
            if (this.checkEmail) {
                this.isShow = show;
                return
            }
            let post = {
            }
            let apiUrl = ''
            if (this.privacyType === 1) { 
                // 心理测评
                apiUrl = AssessApi.getPsychometricsPrivacy;
                post = {
                    candId: this.getUrlParam('candId'),
                    positionId: this.getUrlParam('positionId'),
                    privacyDataName: 'email',
                    userType: 1
                }
            }
            else if (this.privacyType === 2) { 
                // 人格测评
                apiUrl = AssessApi.getPersonalityPrivacy;
                post = {
                    privacyDataName: 'email',
                    userGuid: this.guid,
                    userType: 1,
                }
            }
            else if (this.privacyType === 3) { 
                // 团队测评
                apiUrl = AssessApi.getTeamPrivacy;
                post = {
                    privacyDataName: 'email',
                    userGuid: this.guid,
                    userType: 1,
                }
            }
            else if (this.privacyType === 4) { 
                // 行为测评
                apiUrl = AssessApi.getBehaviorPrivacy;
                post = {
                    candId: this.getUrlParam('candId'),
                    positionId: this.getUrlParam('positionId'),
                    privacyDataName: 'email',
                    userType: 1
                }
            }
            else if (this.privacyType === 5) {
                // 汇总报告
                apiUrl = AssessApi.getReportAllPrivacy;
                post = {
                    candId: this.getUrlParam('candId'),
                    positionId: this.getUrlParam('positionId'),
                    privacyDataName: 'email',
                    userType: 1
                }
            }

            this.$axios.post(apiUrl, post).then((res) => {
                if (res.data.code == 0) {
                    this.checkEmail = res.data.data.privacyData;
                    this.isShow = show;
                }
            }).catch((res) => { })
        },
        //获取url的🔧
        getUrlParam(name) {
            var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)"); //构造一个含有目标参数的正则表达式对象
            var r = window.location.search.substr(1).match(reg); //匹配目标参数
            if (r != null) return unescape(r[2]);
            return null; //返回参数值
        }
    }
}
</script>

<style lang="scss" scoped>
.iconfont {
    margin-left: 10px;
    cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/report/components/email-model.vue